import { useEffect, useRef, useState } from "react";

export function useOnlineStatus() {
  const [isOnline, setIsOnline] = useState(true);
  const [cameOnline, setCameOnline] = useState(false);
  const previousRef = useRef<boolean | null>(null);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const initial = navigator.onLine;
    setIsOnline(initial);
    previousRef.current = initial;

    const handleOnline = () => {
      setIsOnline(true);
      if (previousRef.current === false) {
        setCameOnline(true);
      }
      previousRef.current = true;
    };

    const handleOffline = () => {
      setIsOnline(false);
      setCameOnline(false);
      previousRef.current = false;
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return { isOnline, cameOnline };
}
